import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { AuthHttpHeaderService, AuthService, AuthStorageService, MODULE_INITIALIZER } from '@spartacus/core';
import { effects } from './effects';
import {
  AsmAuthHttpHeaderService,
  AsmAuthService,
  AsmAuthStorageService,
  AsmEnablerService,
  AsmStatePersistenceService,
} from './services';

export function asmStatePersistenceFactory(asmStatePersistenceService: AsmStatePersistenceService): () => void {
  const result = (): void => asmStatePersistenceService.initSync();

  return result;
}

export function asmFactory(asmEnablerService: AsmEnablerService): () => void {
  const isReady = (): void => {
    asmEnablerService.load();
  };

  return isReady;
}

@NgModule({
  imports: [EffectsModule.forFeature(effects)],
  providers: [
    {
      provide: MODULE_INITIALIZER,
      useFactory: asmStatePersistenceFactory,
      deps: [AsmStatePersistenceService],
      multi: true,
    },
    {
      provide: AuthService,
      useExisting: AsmAuthService,
    },
    {
      provide: AuthHttpHeaderService,
      useExisting: AsmAuthHttpHeaderService,
    },
    {
      provide: AuthStorageService,
      useExisting: AsmAuthStorageService,
    },
    provideAppInitializer(() => {
      const initializerFn = asmFactory(inject(AsmEnablerService));

      return initializerFn();
    }),
  ],
})
export class AsmFeatureModule {}
